export const GET_FAQS_LIST = null;
export const SELECTED_FAQ_ID = null;
export const GET_FAQ_BY_ID = null;